import { FormControl } from '@angular/forms';
import { SelectOption } from '../atomic-design/molecules';

export enum Severity {
  Default,
  Warning,
  Success,
  Base,
}

export interface FormField {
  label: string;
  name: string;
  type: 'text' | 'number' | 'email' | 'password' | 'select';
  selectOptions?: SelectOption[];
  controller: FormControl;
  placeholder?: string;
  errorMessage?: string;
}

export interface FilesToUpload {
  file: File;
  src: string;
}
